import script from "./EpicPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./EpicPicker.vue?vue&type=script&setup=true&lang=js"

import "./EpicPicker.vue?vue&type=style&index=0&id=f19f1e00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f19f1e00"]])

export default __exports__